import  moment from 'moment';
class {
    onCreate(input, out){
        this.state = {
            type: input.type,
            timeLeft: null
        }
    }
    
    onRender(out) {
        if (this.state.type == 'trial') {
     
            var endTrialDate = moment(this.input.createdAt).add(1,'days')
            var timeLeft = endTrialDate.diff(moment(), 'days') == 0 ? (endTrialDate.diff(moment(),'hours')==0 ? endTrialDate.diff(moment(),'minutes') + (endTrialDate.diff(moment(), 'minutes') <= 1 ? ' Minute ':' Minutes ') : String(endTrialDate.diff(moment(),'hours'))+(endTrialDate.diff(moment(), 'hours') <= 1 ? ' Hour ':' Hours ')) : null;
            if (!timeLeft) timeLeft = endTrialDate.diff(moment(), 'days') == 1 ? '1 day ' : String(endTrialDate.diff(moment(), 'days'))+' days ';
            this.state.timeLeft = timeLeft.toLowerCase();
        }
    }
}

<!-- <div class="banner">
    <if(input.type == 'trial')>
        <a href=`/account/${input.username}/upgrade` class="banner-background" style="cursor: default;background-color: #6936f5;position: absolute;width: 100vw;height: 100%;z-index: 1;opacity: 1;"></a>
        <p style="z-index: 2; display: inherit; font-size: 15px;">
            <a href=`/account/${input.username}/upgrade` style="color: white;-webkit-font-smoothing: antialiased;">You have ${state.timeLeft} of free trial left<span class="d-none d-sm-inline-block" style="margin-left: 8px;"> — </span></a>
            <a href=`/account/${input.username}/upgrade` class="banner-button w-button" style="z-index: 2;color: #fff;font-weight: 500;margin-left: 9px;text-align: center;border-bottom: 2px solid #fff;padding-bottom: 0px;display: inline-flex;position: relative;margin-top: -2px;">Upgrade Now & Start Growing</a>
        </p>
    </if>
</div> -->

<style>
    .nk-header-fixed + .nk-content {
        margin-top: 100px !important;
    }
    .link-description-text {
        display: none;
    }
    .banner {
        overflow: hidden;
        -webkit-box-align: center;
        -webkit-box-pack: center;
        align-items: center;
        background-color: #6936f5;
        color: #fff;
        display: flex;
        justify-content: center;
        padding: 13px 16px;
        position: relative;
        margin-left: -22px !important;
        width: calc(100% + 45px) !important;
    }
    .banner-paragraph-tag {
        border-width: 1px;
        display: inline-block;
    }
    .banner-label {
        background-color: #fff;
        border-radius: 20px;
        color: #6936f5;
        padding: 1px 12px;
        -webkit-font-smoothing: antialiased;
    }
    @media screen and (max-width: 767px) {
        .banner {
            -webkit-box-align: start;
            -webkit-box-direction: normal;
            -webkit-box-orient: vertical;
            align-items: flex-start;
            flex-direction: column;
            padding: 12px 64px 12px 24px;
            row-gap: 8px;
            white-space: nowrap;
            text-align: center;
            width: 100%;
            justify-content: center;
            margin: 0 auto;
            display: block;
        }
        .banner-label, .banner-background{
            display: none;
        }
        .header {
            margin-top: 50px !important;
        }
    }
    @media screen and (max-width: 479px) {
        .banner {
            padding-right: 24px;
        }
        .label.small.banner-link {
            display:none;
        }
    }
    .w-embed::after {
        clear: both;
        content: " ";
        display: table;
        grid-column-end: 2;
        grid-column-start: 1;
        grid-row-end: 2;
        grid-row-start: 1;
    }
    .label.small {
        font-size: 14px;
        position: relative;
    }
    .paragraph.small {
        font-size: 16px;
    }
    .label.small.banner-paragraph-tag {
        background-color: rgba(255, 255, 255, .1);
        border-color: rgba(255, 255, 255, .1);
        border-radius: 20px;
        border-style: solid;
        margin-left: 3px;
        margin-right: 3px;
        font-weight: 600;
        padding-left: 7px;
        padding-right: 7px;
    }
    .label.small.banner-link {
        color: #fff;
        margin-left: 16px;
    }
    @media screen and (max-width: 535px) {
        .banner-button {
            display: none !important; 
        }
    }
    @media screen and (max-width: 991px) {
        .label.small.banner-link {
            margin-left: 4px;
        }
    }
    @media screen and (max-width: 767px) {
        .label.small.banner-link {
            margin-left: 4px;
        }
    }
    @media screen and (max-width: 479px) {
        .label.small.banner-link {
            white-space: nowrap;
        }
    }
    .label.small.banner-link:hover {
        opacity: .6;
    }
</style>

<script type="text/javascript">document.body.style.paddingBottom = '110px';</script>